export default async function MMGraficoRelatorio(
    h,
    mediaAgrupadorList,
    metaUsar,
    titulo,
    groupByConfig,
    apontamentos,
    paramsCliente,
    dataInicio,
    dataFim,
    primeiro
) {
    return [
        (primeiro ? "" : h.pageBreak({ pageOrientation: 'portrait' })),
        h.row(
            h.text(
                "Muda Mecanizada não possui gráfico",
                { alignment: "center", fontSize: 32, colSpan: 2 }
            ),
        )
    ]
}